import axios from 'axios'

export const getSetting = (id, params) => {
  return axios.get('settings/' + id, {params: params})
}

export const updateSetting = (id, data) => {
  return axios.put('settings/' + id, data)
}



// WEBPACK FOOTER //
// ./src/api/settings.js